/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
// import { packageActions } from "./packageSlice";
import packageApi from "api/packagesApi";
import { PackageAddForm, PackageUpdateForm } from "models/package";
import couponManageApi from "api/couponManageApi";
import { couponManageActions } from "./couponManageSlice";
// }

function* getCoupons(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      couponManageApi.getCouponList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(couponManageActions.getCouponSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(couponManageActions.getCouponFailed(errorData));
  }
}

function* addCoupon(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      couponManageApi.addCoupon,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(couponManageActions.addCouponSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(couponManageActions.addCouponFailed(errorData));
  }
}

function* updateCoupon(action: PayloadAction<PackageUpdateForm>) {
  try {
    const response: ApiResponse = yield call(
      couponManageApi.updateCoupon,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(couponManageActions.updateCouponSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(couponManageActions.updateCouponFailed(errorData));
  }
}

function* deleteCoupon(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      couponManageApi.deleteCoupon,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(couponManageActions.deleteCouponSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(couponManageActions.deleteCouponFailed(errorData));
  }
}

function* getImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      couponManageApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(couponManageActions.getImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(couponManageActions.getImageUrlFailed(errorData));
  }
}

export default function* couponManageSaga() {
  yield takeLatest(couponManageActions.getImageUrl.type, getImageUrl);
  yield takeLatest(couponManageActions.getCoupon.type, getCoupons);
  yield takeLatest(couponManageActions.addCoupon.type, addCoupon);
  yield takeLatest(couponManageActions.updateCoupon.type, updateCoupon);
  yield takeLatest(couponManageActions.deleteCoupon.type, deleteCoupon);
}
